<template>
  <div class="vm-nav-header-pc">
    <div class="inner-box flex-box flex-align-items-center flex-justify-content-space-between">
      <div class="flex-box flex-align-items-center">
        <router-link :to="{name: 'index'}" class="flex-box flex-align-items-center fs-24-16 mq">
          <img class="logo-img mr-24-16 mq" src="/static/img/logo/logo.png" alt />
          <span class="purple">{{$t('c.NavHeaderArticleEditPC.text1')}}</span>
        </router-link>
      </div>
      <div class="relative flex-box flex-align-items-center" v-if="session_user">
        <slot name="multiselect"></slot>
        <slot name="action"></slot>
        <!-- <btn :text="`<span>发布</span>`" class="mr24" @click.native="submit"></btn> -->
        <div @mouseenter="show_menu" @mouseleave="close_menu">
          <div class="pointer avatar-box" @click="show_menu">
            <pic class="circle" :src="session_user.avatar" width="40" height="40"></pic>
          </div>
          <div class="menu" v-if="session_user && is_show_menu" v-click-outside="close_menu">
            <div class="menu-inner-box">
              <div class="type-1">
                <router-link v-if="is_creator" :to="$userlink(session_user)" class="link-1">{{$t('c.NavHeaderArticleEditPC.text2')}}</router-link>
                <router-link v-else :to="{name: 'apply'}" class="link-1">{{$t('c.NavHeaderArticleEditPC.text3')}}</router-link>
              </div>
              <div class="type-2">
                <router-link v-if="!is_creator" :to="$userlink(session_user)" class="link-2">{{$t('c.NavHeaderArticleEditPC.text4')}}</router-link>
                <router-link :to="{name: 'dashboardStats'}" class="link-2 gl-hover-text">{{$t('c.NavHeaderArticleEditPC.text5')}}</router-link>
                <router-link :to="{name: 'settingAccount'}" class="link-2 gl-hover-text">{{$t('c.NavHeaderArticleEditPC.text6')}}</router-link>
                <!--<router-link v-if="is_creator" :to="{name: 'settingCreator'}" class="link-2 gl-hover-text">创作设置</router-link>-->
                <router-link :to="{name: 'myBill'}" class="link-2 gl-hover-text">{{$t('c.NavHeaderArticleEditPC.text7')}}</router-link>
                <router-link
                  v-if="browser_size == 'small' && auth_token"
                  to="/album/248b4bb2c9b111e9a9bb52540025c377/92aa33b68b4a11e8aa6952540025c377"
                  class="link-2 gl-hover-text"
                >{{$t('c.NavHeaderArticleEditPC.text8')}}</router-link>
                <div class="link-2 gl-hover-text" @click="logout">{{$t('c.NavHeaderArticleEditPC.text9')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {  } from "@/api/config";
import { mapState } from "vuex";
export default {
  name: "nav-header-article-edit-pc",
  props: {},
  computed: {
    ...mapState("app", [
      "session_user",
      "user_status",
      "auth_token",
      "browser_size",
      "unread_message_num"
    ]),
    is_creator() {
      if (
        this.session_user &&
        this.session_user.creator &&
        this.session_user.creator.status
      ) {
        return true;
      }
      return false;
    }
  },
  watch: {
    query(v) {
      this.$store.dispatch("app/set:q", v);
    }
  },
  data() {
    return {
      is_show_menu: false,
      query: this.$route.query.q || ""
    };
  },
  mounted() {},
  methods: {
    search() {
      this.$router.push({ name: "search", query: { q: this.query } });
    },
    show_modal_feed() {
      this.$mixin_show_modal_feed();
    },
    show_menu(a) {
      this.is_show_menu = true;
    },
    close_menu() {
      this.is_show_menu = false;
    },
    logout() {
      this.$bus.$emit("SESSION_EXPIRED",{is_request_logout: true});
      this.$router.push({ name: "login" });
    },
    submit() {
      this.$emit("submit");
    }
  }
};
</script>
<style lang="stylus" scoped>
.vm-nav-header-pc {
  position: fixed;
  left: 0;
  top: 0;
  // transform translate(-50%,0)
  width: 100%;
  background: $white-bg;
  box-sizing: border-box;
  z-index: 99;
  height: px2rem(80);
  display: flex;

  .logo-img {
    width: px2rem(40);
    height: px2rem(40);
  }

  .inner-box {
    border-bottom: 1px solid $grey;
    // padding px2rem(24) 0
    box-sizing: border-box;
    max-width: $width-pc;
    margin: 0 auto;
    width: 100%;
  }

  .avatar-box {
    width: px2rem(32);
    height: px2rem(32);
  }

  .menu {
    padding: 0 px2rem(16);
    background: $white;
    position: absolute;
    width: px2rem(160);
    box-sizing: border-box;
    border-radius: px2rem(2);
    border: 1px solid $black-1;
    right: 0;
    top: px2rem(30);

    .type-1 {
      border-bottom: 1px solid $black-1;

      .link-1 {
        color: $purple;
        padding: px2rem(16) 0;
        display: block;
      }
    }

    .type-2 {
      padding: px2rem(8) 0;

      .link-2 {
        padding: px2rem(8) 0;
        display: block;
        color: $black-8;
        cursor: pointer;
      }
    }
  }

  .message-remind-box {
    .vm-tag {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(70%, -60%);
    }
  }

  .explore-door {
    &.on {
      position: relative;
      color: $purple;

      .line-active {
        height: 2px;
        background: $purple;
        width: 100%;
        position: absolute;
        bottom: _px2rem(29);
      }
    }
  }

  .multiselect-permission {
    background: $white-bg !important;
  }

  @media (min-width: $width-mobile + 1) and (max-width: $width-pc) {
    padding: 0 px2rem(24);
  }
}
</style>
